import React from 'react';
import PropTypes from 'prop-types';
export default class BizTag extends React.Component {
    render() {
        let classname = 'bizTag';
        if (this.props.bottom) {
            classname = 'bizTag-bottom';
        }
        return React.createElement("span", { className: classname });
    }
}
BizTag.propTypes = {
    bottom: PropTypes.bool,
};
